import { render } from "./SpreadsheetForm.vue?vue&type=template&id=05cc3374&scoped=true"
import script from "./SpreadsheetForm.vue?vue&type=script&lang=js"
export * from "./SpreadsheetForm.vue?vue&type=script&lang=js"

import "./SpreadsheetForm.vue?vue&type=style&index=0&id=05cc3374&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05cc3374"

export default script